<template>
  <section class="content-section primary">
    <div class="section-title">
        <!-- <div class="section-title-line"></div> -->
        <h1>GRANIT UND HARTGESTEINE</h1>
        <!-- <div class="section-title-line"></div> -->
    </div>
    <div class="container">
      <article class="detailed-info">
        <p>Zu den Hartgesteinen gehören alle Erstarrungsgesteine, auch Tiefengesteine genannt. Dazu zählen unter anderem Granit und Gabbro. Aber auch Ergussgesteine wie Basalt und Diabas, sowie Gneise gehören den Hartgesteinen an. Sie zeichnen sich besonders durch ihre große Härte, die Abriebfestigkeit und ihre hohe chemische Resistenz gegenüber Säuren aus. Auch besitzen Sie zumeist eine hohe Frost- und Hitzebeständigkeit und sind besonders kratzfest, wodurch sie auch sehr pflegeleicht sind.</p>
        <hr>
        <h2>Granit - Der Alleskönner</h2>
        <p>Durch ihre besonderen Eigenschaften werden Hartgesteine wie Granit häufig als Bodenbeläge eingesetzt. Sowohl im Innen- als auch im Außenbereich. Durch moderne Fertigungsanlagen und Diamantsägetechnik sind sie heutzutage sogar vergleichsweise preiswert erhältlich.<br><br>Granit und Hartgesteine bekommen Sie bei uns poliert, geschliffen, satiniert, antik oder auch geflammt.</p>
        <hr>
        <div class="image-row">
      <div class="image-row-item"><img src="https://marmor-kunze.de/static/images/material/granit1.jpg"></div>
      <div class="image-row-item"><img src="https://marmor-kunze.de/static/images/material/granit2.jpg"></div>
      <div class="image-row-item"><img src="https://marmor-kunze.de/static/images/material/granit3.jpg"></div>
        </div>
      </article>
      </div>
    </section>
</template>

<script>
export default {
  name: 'Hartgesteine',
  metaInfo: {
    title: 'Hartgesteine',
    meta:[
      { vmid: 'description', name: 'description', content: "Zu den Hartgesteinen gehören alle Erstarrungsgesteine, auch Tiefengesteine genannt. Dazu zählen unter anderem Granit und Gabbro. Aber auch Ergussgesteine wie Basalt und Diabas, sowie Gneise gehören den Hartgesteinen an."},
      { vmid: 'keywords', name: 'keywords', content: "Hartgesteine, Granit, Gabbro, Basalt, Diabas, Gneise, Natursteine, Natursteinhandel Mönchengladbach"},
      
    ],
    links: [ {rel: 'canonical', href: 'https://www.marmor-kunze.de/material/granit-und-hartgesteine'} ]
  },
 
}
</script>
j
<style>
</style>



// WEBPACK FOOTER //
// src/components/views/Hartgesteine.vue